import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container, Typography, Grid, useTheme } from '@mui/material';
import { SectionHeader } from './sectionHeader';
import { SectionBox } from './sectionBox';
const ComplianceFeatureItem = ({ feature }) => {
    const theme = useTheme();
    return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'flex-start' }, children: [_jsx(Box, { sx: {
                    mr: 5,
                }, children: _jsx(Box, { component: "img", src: feature.icon, alt: feature.title }) }), _jsxs(Box, { sx: { flex: 1 }, children: [_jsx(Typography, { variant: "h3", sx: {
                            mb: 2,
                            fontSize: '18px',
                        }, children: feature.title }), _jsx(Typography, { variant: "body2", sx: {
                            color: theme.palette.text.secondary,
                        }, children: feature.description })] })] }));
};
export const PrivacySection = ({ label, title, subtitle, features, image, imageAlt, }) => {
    const theme = useTheme();
    return (_jsx(SectionBox, { background: theme.palette.background.paper, children: _jsxs(Container, { maxWidth: "lg", sx: { px: { xs: 4, md: 6 } }, children: [_jsx(SectionHeader, { label: label, title: title, subtitle: subtitle, align: "left", maxWidth: 600, marginBottom: 8 }), _jsxs(Grid, { container: true, spacing: 24, alignItems: "center", sx: { pt: 4 }, children: [_jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 6 }, children: features.map((feature) => (_jsx(ComplianceFeatureItem, { feature: feature }, feature.id))) }) }), _jsx(Grid, { size: { xs: 12, md: 6 }, children: _jsx(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    justifyContent: 'center',
                                }, children: _jsx(Box, { component: "img", src: image, alt: imageAlt, sx: {
                                        width: '100%',
                                        maxWidth: '100%',
                                        height: 'auto',
                                    } }) }) })] })] }) }));
};
